import { useFormContext } from 'react-hook-form';
import { SwitchCase } from '@toss/react';
import { Provider } from 'jotai';
import { ProfileContainer } from '../share/UserProfile/ProfileWidget';
import { CompanyEditForm, NormalEditForm, StudentEditForm, TeacherEditForm } from './form';
import { ProfileAvatarCard } from './ProfileAvatarCard';
import { type ProfileEditFormData } from './schema';
export const ProfileEditForm = () => {
  const {
    getValues
  } = useFormContext<ProfileEditFormData>();
  const userType = getValues('userType');
  return <Provider data-sentry-element="Provider" data-sentry-component="ProfileEditForm" data-sentry-source-file="ProfileEditForm.tsx">
      <ProfileContainer className="max-w-[640px] rounded-xl p-lg mobile-lg:p-2xl" data-sentry-element="ProfileContainer" data-sentry-source-file="ProfileEditForm.tsx">
        <ProfileAvatarCard data-sentry-element="ProfileAvatarCard" data-sentry-source-file="ProfileEditForm.tsx" />
        <SwitchCase value={userType} caseBy={{
        student: <StudentEditForm />,
        teacher: <TeacherEditForm />,
        company: <CompanyEditForm />,
        normal: <NormalEditForm />
      }} defaultComponent={<NormalEditForm />} data-sentry-element="SwitchCase" data-sentry-source-file="ProfileEditForm.tsx" />
      </ProfileContainer>
    </Provider>;
};